// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2MRZO","footerText":"Footer_footerText__24uoU","spin":"Footer_spin__1fXlG","transition-opacity":"Footer_transition-opacity__ns89_"};